import {useState, useEffect} from 'react';
import axios from "../utils/axios";

export function useSeoData(path) {
  const [seo, setSeo] = useState({});

  async function getSeoData(path) {
    try {
      const response = await axios.get(`/seo/seo_por_path?path=${path}`);
      setSeo(response.data.data)
    } catch(err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getSeoData(path);
  }, [])

  return { seo };
}
